(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haciendola-plus-propuesta"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const filters = root.querySelectorAll('[data-filter]');
    filters.forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.filter;
      filters.forEach(item => { item.classList.toggle('active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
      let count = 0;
      root.querySelectorAll('[data-level]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.level !== filter; if (!card.hidden) count++; });
      const note = root.querySelector('.course-count');
      if(note) note.textContent = note.dataset.countTemplate.replace('__COUNT__', String(count));
    }));
    root.querySelectorAll('.faq-list details').forEach(item => item.addEventListener('toggle', () => { if(item.open) root.querySelectorAll('.faq-list details').forEach(other => { if(other !== item) other.open = false; }); }));
    const dialog = root.querySelector('.video-dialog');
    if(dialog) {
      const player = dialog.querySelector('video');
      const title = dialog.querySelector('#video-title');
      const error = dialog.querySelector('.video-error');
      const fallback = dialog.querySelector('.video-source');
      root.querySelectorAll('[data-video]').forEach(button => button.addEventListener('click', () => {
        title.textContent = button.dataset.videoTitle;
        error.hidden = true;
        fallback.href = button.dataset.video;
        error.querySelector('a').href = button.dataset.video;
        player.src = button.dataset.video;
        dialog.showModal();
        player.play().catch(() => {});
      }));
      dialog.querySelector('[data-close-video]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if(event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { player.pause(); player.removeAttribute('src'); player.load(); });
      player.addEventListener('error', () => { error.hidden = false; });
    }
    const variantSelect = root.querySelector('[data-variant-select]');
    if (variantSelect) variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      root.querySelectorAll('[data-product-price]').forEach(el => el.textContent = option.dataset.price);
      const purchase = root.querySelector('button[data-purchase]');
      const available = option.dataset.available === 'true';
      purchase.disabled = !available;
      purchase.querySelector('[data-purchase-label]').textContent = available ? purchase.dataset.availableLabel : purchase.dataset.soldLabel;
    });
    const sticky = root.querySelector('.mobile-cta');
    const price = root.querySelector('#acceso');
    if (sticky && price && 'IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold: .1}); observer.observe(price); }
  };
  document.querySelectorAll('.hp-site').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.hp-site').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
